import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=9bc3bef8&scoped=true&"
import script from "./notfound.vue?vue&type=script&lang=js&"
export * from "./notfound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc3bef8",
  null
  
)

export default component.exports